import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import TemplateStep3 from "Components/Templates/Step3";

export default function PageStep3() {
   console.log("step 3");
   const data = useSelector((state: any) => state.data);
   const navigate = useNavigate();

   function nextOnClick() {
      if (data.temp_files.length === 0) {
         Swal.fire({
            icon: "info",
            title: "아래 메일로 파일을 보내주세요",
            text: "contact@art-map.co.kr",
         }).then(() => {
            navigate("/steps/4");
         });
      } else {
         navigate("/steps/4");
      }
   }

   return (
      <>
         <TemplateStep3 nextOnClick={nextOnClick}></TemplateStep3>
      </>
   );
}
